import { render } from "./PaymentTab.vue?vue&type=template&id=6dd4a896"
import script from "./PaymentTab.vue?vue&type=script&lang=js"
export * from "./PaymentTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__